import axios from "../config/axios-chatbot";

// Every call is scoped to a registry (usermanagement) project: /api/project/{projectId}/ami, with X-Project-Id
// equal to the path id. Extensions and blocks are owned by (projectId, sub_project_id).
const base = (projectId) => `/api/project/${projectId}/ami`;
const config = (projectId, params) => ({headers: {"X-Project-Id": projectId}, ...(params ? {params} : {})});

export const AmiRepository = {
  // Health
  getHealth: (projectId) => {
    return axios.get(`${base(projectId)}/health`, config(projectId));
  },

  // Channels (global admins only)
  listChannels: (projectId) => {
    return axios.get(`${base(projectId)}/channels`, config(projectId));
  },
  getChannelVar: (projectId, channel, variable) => {
    return axios.get(`${base(projectId)}/channels/vars`, config(projectId, {channel, variable}));
  },
  setChannelVar: (projectId, channel, data) => {
    return axios.post(`${base(projectId)}/channels/vars`, data, config(projectId, {channel}));
  },
  hangupChannel: (projectId, channel, data = {}) => {
    return axios.post(`${base(projectId)}/channels/hangup`, data, config(projectId, {channel}));
  },
  redirectChannel: (projectId, channel, data) => {
    return axios.post(`${base(projectId)}/channels/redirect`, data, config(projectId, {channel}));
  },

  // Extensions; subProjectId narrows the list to one sub project
  listExtensions: (projectId, subProjectId) => {
    return axios.get(`${base(projectId)}/extensions`,
      config(projectId, subProjectId ? {subProjectId} : undefined));
  },
  // A new extension needs sub_project_id; omitted extension = next free slot of the owner's block
  registerExtension: (projectId, data) => {
    return axios.post(`${base(projectId)}/extensions`, data, config(projectId));
  },
  getExtension: (projectId, exten) => {
    return axios.get(`${base(projectId)}/extensions/${exten}`, config(projectId));
  },
  deleteExtensionById: (projectId, extId) => {
    return axios.delete(`${base(projectId)}/extensions/id/${extId}`, config(projectId));
  },
  enableExtension: (projectId, exten) => {
    return axios.post(`${base(projectId)}/extensions/${exten}/enable`, null, config(projectId));
  },
  disableExtension: (projectId, exten, data = {}) => {
    return axios.post(`${base(projectId)}/extensions/${exten}/disable`, data, config(projectId));
  },
  redirectExtension: (projectId, exten, data) => {
    return axios.post(`${base(projectId)}/extensions/${exten}/redirect`, data, config(projectId));
  },
  // Asterisk-wide (global admins only)
  resyncExtensions: (projectId) => {
    return axios.post(`${base(projectId)}/extensions/resync`, null, config(projectId));
  },
  regenerateConf: (projectId) => {
    return axios.post(`${base(projectId)}/extensions/regenerate-conf`, null, config(projectId));
  },
  reloadDialplan: (projectId) => {
    return axios.post(`${base(projectId)}/dialplan/reload`, null, config(projectId));
  },

  // Extension blocks / slots
  listExtensionBlocks: (projectId) => {
    return axios.get(`${base(projectId)}/extensions/blocks`, config(projectId));
  },
  // data: {sub_project_id, block_size?}
  reserveExtensionBlock: (projectId, data) => {
    return axios.post(`${base(projectId)}/extensions/blocks`, data, config(projectId));
  },
  getAvailableSlots: (projectId, subProjectId) => {
    return axios.get(`${base(projectId)}/extensions/slots/available`,
      config(projectId, subProjectId ? {subProjectId} : undefined));
  },

  // Calls; data.extension_id or data.extension must be one of the project's extensions
  originateCall: (projectId, data) => {
    return axios.post(`${base(projectId)}/calls/originate`, data, config(projectId));
  },
};
